import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import ExpandableContent from '../../../../src/ui/expandableContent.jsx'

import FlightHeader from './components/FlightHeader.js'
import FlightInformation from './components/FlightInformation.js'
import FlightSummary from './components/FlightSummary.js'
import InvalidFlightInfo from './components/InvalidFlightInfo.jsx'

const InnerLayoutStyled = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: auto;
`

const MainContent = styled.div`
`

const FlightHeaderStyled = styled(FlightHeader)`
  flex: 1 0 auto;
  padding: 2px 12px 12px 12px;
`

class InnerLayout extends React.Component {
  componentDidMount () {
    this.props.getSize(this.elementRef.scrollHeight)
  }

  componentDidUpdate (prevProps) {
    if (this.props.doReportSize) {
      this.props.getSize(this.elementRef.scrollHeight)
      this.props.setDoReportSize(false)
    }

    if (prevProps.state.flightId !== this.props.state.flightId) {
      this.props.notifyAboutChange()
    }
  }

  // Check the initial content height
  refCallback = element => {
    if (element) {
      this.elementRef = element
      this.props.getSize(element.scrollHeight)
    }
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.state.flightId !== this.props.state.flightId) {
      return true
    }
    return false
  }

  render () {
    const { className, T, state, onCloseClicked, onGetDirectionClick } = this.props
    const { flightInfo } = state

    if (!flightInfo)
      return <InnerLayoutStyled className={className}>
        <MainContent ref={this.refCallback}>
          <InvalidFlightInfo T={T} onCloseClicked={onCloseClicked}/>
        </MainContent>
      </InnerLayoutStyled>

    return (
      <InnerLayoutStyled className={className}>
        <MainContent ref={this.refCallback}>
          <FlightHeaderStyled T={T} flightInfo={flightInfo} onCloseClicked={onCloseClicked} onGetDirectionClick={onGetDirectionClick} />
          <FlightSummary flightInfo={flightInfo} />
        </MainContent>
        <FlightInformation flightInfo={flightInfo} />
      </InnerLayoutStyled>
    )
  }
}

const FlightDetailsWidgetMobile = (props) => {
  const [innerComponentHeight, setInnerComponentHeight] = useState(false)
  const [doReportSize, setDoReportSize] = useState(true)
  const { T, id, state } = props

  // If POI has changed calculate inner size
  useEffect(() => {
    if (!doReportSize) setDoReportSize(true)
  }, [props.poi])

  return <ExpandableContent
    id={id}
    initialHeight={innerComponentHeight ? `${innerComponentHeight + 19}px` : '50vh'} // add 19px of accordion
    maxHeight={'100vh'}
    bus={props.bus}
    T={T}
    poi={state?.flightInfo}>
    <InnerLayout {...props} doReportSize={doReportSize} setDoReportSize={value => setDoReportSize(value)} getSize={innerComponentHeight => setInnerComponentHeight(innerComponentHeight)} />
  </ExpandableContent>
}

export default FlightDetailsWidgetMobile
